import React from 'react';

/**
 * FormSection - Form section wrapper with consistent styling
 * Provides visual grouping for form fields
 */
export const FormSection = ({ 
  title, 
  subtitle,
  icon,
  children, 
  className = '',
  collapsible = false,
  defaultCollapsed = false
}) => {
  const [isCollapsed, setIsCollapsed] = React.useState(defaultCollapsed);

  return (
    <div className={`bg-white rounded-xl border border-gray-200 p-6 ${className}`}>
      {(title || subtitle || icon) && (
        <div 
          className={`flex items-center justify-between mb-6 ${collapsible ? 'cursor-pointer' : ''}`}
          onClick={() => collapsible && setIsCollapsed(!isCollapsed)}
        >
          <div className="flex items-center gap-3">
            {icon && (
              <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                {icon}
              </div>
            )}
            <div>
              {title && (
                <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
              )}
              {subtitle && (
                <p className="text-sm text-gray-600 mt-0.5">{subtitle}</p>
              )}
            </div>
          </div>
          {collapsible && (
            <svg
              className={`w-5 h-5 text-gray-500 transition-transform ${isCollapsed ? '' : 'rotate-180'}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          )}
        </div>
      )}
      {!isCollapsed && (
        <div className="space-y-4">
          {children}
        </div>
      )}
    </div>
  );
};

export default FormSection;
